import { yupResolver } from "@hookform/resolvers/yup";
import { FormGroup } from "@itandi/itandi-bb-ui/FormGroup";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { ConstructionForm } from "~/components/common/constructions/ConstructionForm";
import type { NskResponse } from "~/models/Api";
import type { DealConstructionEdit } from "~/models/DealConstruction";
import {
	buildDefaultConstruction,
	validationSchemaConstruction
} from "~/models/DealConstruction";
import type { DealConstructionItem } from "~/models/DealConstructionItem";
import { isSuccess } from "~/utils/api/api_handler";
import { ConstructionFormFooter } from "../ConstructionFormFooter";

type Props = {
	dealConstructionItems: DealConstructionItem[];
	disabled?: boolean;
	docType: "estimation" | "billing";
	handleCreate: (submitValue: DealConstructionEdit) => Promise<NskResponse>;
	mutateConstructions: () => Promise<void>;
};

export const ConstructionAddForm: React.FC<Props> = ({
	dealConstructionItems,
	handleCreate,
	mutateConstructions,
	disabled = false,
	docType
}: Props) => {
	const methods = useForm<DealConstructionEdit>({
		defaultValues: buildDefaultConstruction("add"),
		mode: "onBlur",
		resolver: yupResolver(validationSchemaConstruction)
	});
	const onClickSubmit = React.useCallback(() => {
		methods.handleSubmit(async () => {
			const response = await handleCreate(methods.getValues());
			if (isSuccess(response)) {
				await mutateConstructions();
				methods.reset();
				toast.success("追加しました");
				return;
			}
			toast.error("エラーが発生しました");
			methods.reset();
		})();
	}, [handleCreate, methods, mutateConstructions]);

	return (
		<FormProvider {...methods}>
			<FormGroup variant="vertical">
				<ConstructionForm
					dealConstructionItems={dealConstructionItems}
					disabled={disabled}
					docType={docType}
				/>
			</FormGroup>
			<ConstructionFormFooter
				disabled={disabled || methods.formState.isSubmitting}
				onClickSubmit={onClickSubmit}
				type="add"
			/>
		</FormProvider>
	);
};
